export default "__VITE_ASSET__BmcSNtwv__"